import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType, WorkflowComponentParameterMode } from '../types';
import { SINGLE_OUTPUT_NAME, SingleOutputWorkflowComponent } from './common/singleoutputcomponent';
class CronbachAlphaCoefficient extends SingleOutputWorkflowComponent {
    constructor() {
        super({
            name: 'native.cronbachalphacoefficient',
            group: 'Statistics',
            title: 'Cronbach Alpha Coefficient',
            description: `
        This component computes the Cronbach Alpha Coefficient,
        which can be used to measure internal consistency of different variables.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'variablecolumns',
                type: WorkflowComponentParamType.Column,
                title: 'Input variables',
                parent: 'source',
                mode: WorkflowComponentParameterMode.Multiple,
                dataType: [ColumnDataType.Number]
            }
        ]);
        this.supportedProviders = [Provider.BigQuery, Provider.Snowflake];
    }
    async getCode({ workflow, params, connection, envVars, codeType, schemas }) {
        const preparedParams = this._prepareParameters(params);
        const tablename = connection.getOutputTableName(workflow.id, this.metadata.name, params, SINGLE_OUTPUT_NAME, codeType);
        const columns = preparedParams.variablecolumns;
        const query = dedent `
          CALL ${connection.quoteName(envVars.analyticsToolboxDataset)}.CRONBACH_ALPHA_COEFFICIENT(
            'SELECT ${columns.join(', ')} FROM ${connection.quoteName(preparedParams.source)}',
            '${tablename}');`;
        return {
            outputs: { result: tablename },
            query
        };
    }
    requiredAnalyticsToolboxVersion(provider) {
        switch (provider) {
            case Provider.Snowflake:
                return '1.8.0';
            default:
                return '1.0.0';
        }
    }
    getVersion(provider) {
        return '1.0.0';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema() {
        return [
            {
                name: 'cronbach_alpha_coef',
                type: ColumnDataType.Number
            },
            {
                name: 'k',
                type: ColumnDataType.Number
            },
            {
                name: 'mean_var',
                type: ColumnDataType.Number
            },
            {
                name: 'mean_cov',
                type: ColumnDataType.Number
            }
        ];
    }
}
export { CronbachAlphaCoefficient };
